const extension = {
  img: ['jpeg', 'jpg', 'png', 'webp'],
  mimeImg: ['image/jpeg', 'image/png', 'image/webp'],
  file: ['pdf', 'txt', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'potx', 'xps', 'vsdx', 'csv', 'zip', 'rar', 'mp4', 'mov', 'mp3', '7z', 'py', 'cpp'],
  mimeFile: [
    'application/pdf',
    'text/plain',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.openxmlformats-officedocument.presentationml.template',
    'application/vnd.ms-xpsdocument',
    'application/vnd.visio',
    'text/csv',
    'video/mp4',
    'video/quicktime',
    'audio/mpeg',
    'text/x-python',
    'text/x-c++src',

    // todos os tipos de types para rar, zip, 7z
    'application/zip',
    'application/x-zip-compressed',
    'multipart/x-zip',
    'application/x-compressed',
    'application/vnd.rar',
    'application/x-rar-compressed',
    'application/rar',
    'application/x-rar',
    'application/x-7z-compressed',
    'application/x-7z',
    'application/7z-compressed',
  ]
}

export default extension;
